function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.938.456V2.66h2.852l-3.632 3.632 1.559 1.558 3.632-3.632v2.853h2.204V.456h-6.615zM14.756 10.653L20 15.897l-2.666 2.666A4.928 4.928 0 0113.812 20C7.743 20 0 12.256 0 6.189a5 5 0 01.367-1.905 4.939 4.939 0 011.07-1.618L4.103 0l5.244 5.244L5.895 8.7a10.147 10.147 0 005.401 5.412l3.46-3.46z",
  fill: "#39C360"
})));